<template>
  <span>
    <span><slot></slot></span>
    <transition :name="animation">
      <div class="dropdown-content" v-show="visible" :style="ddStyle">
          <slot name="dropdown"></slot>
      </div>
    </transition>
  </span>

</template>

<script type="text/javascript">
function getSize($ele) {
    let $clone = $ele.cloneNode(true)
    let size = {}

    $clone.style.display = 'block'
    $clone.style.visibility = 'hidden'
    $clone.style.position = 'absolute'
    $ele.parentNode.insertBefore($clone, $ele)
    
    size.width = $clone.offsetWidth
    size.height = $clone.offsetHeight
    // $clone.remove()
    $ele.parentNode.removeChild($clone)
    return size
}
function setPosition($link, $dd, position, margin) {
    let refSize = getSize($link)
    let cornerPos = {}
    let outStyle = {}
    let origin = {}
    let [ p1, p2, p3, p4 ] = position
    let rect = $link.getBoundingClientRect()
    let refPos = { top: 0, left: 0 }
    let dpSize = getSize($dd)
    let parentPosition = document.defaultView.getComputedStyle($link.offsetParent).position

    switch (parentPosition.toLowerCase()) {
        case 'fixed':
            refPos.left = rect.left - $link.offsetParent.offsetLeft
            refPos.top = rect.top - $link.offsetParent.offsetTop
            break

        case 'absolute':
        case 'relative':        
            let parentRect = $link.offsetParent.getBoundingClientRect()
            refPos.left = rect.left - parentRect.left
            refPos.top = rect.top - parentRect.top
            break

        default: 
            refPos.left = rect.left - $link.offsetParent.offsetLeft + window.pageXOffset
            refPos.top = rect.top - $link.offsetParent.offsetTop + window.pageYOffset
    }

    cornerPos.left = refPos.left
    switch (p1) {
        case 'center':
        cornerPos.left += refSize.width / 2
        break

        case 'right':
        cornerPos.left += refSize.width
        break
    }

    cornerPos.top = refPos.top
    switch (p2) {
        case 'center':
        cornerPos.top += refSize.height / 2
        break
        case 'bottom':
        cornerPos.top += refSize.height
        break
    }

    switch (p3) {
        case 'left':
        outStyle.left = Math.round(cornerPos.left)
        origin.left = 'left'
        break

        case 'center':
        outStyle.left = Math.round(cornerPos.left - dpSize.width / 2)
        origin.left = 'center'
        break

        default:
        outStyle.left = Math.round(cornerPos.left - dpSize.width)
        origin.left = 'right'
    }

    switch (p4) {
        case 'top':
        outStyle.top = Math.round(cornerPos.top)
        origin.top = 'top'
        break

        case 'center':
        outStyle.top = Math.round(cornerPos.top - dpSize.height / 2)
        origin.top = 'center'
        break

        default:
        outStyle.top = Math.round(cornerPos.top - dpSize.height)
        origin.top = 'bottom'
    }

    outStyle.left = (outStyle.left + margin[0]) + 'px'
    outStyle.top = (outStyle.top + margin[1]) + 'px'
    outStyle.transformOrigin = origin.left + ' ' + origin.top
    outStyle.position = 'absolute'
    return outStyle
}

  export default {
    name: 'Dropdown',
    props: {
        trigger:{
            type: String,
            default:'mouseout'
        },
        items: {
            type: Array,
            default: ()=>[]
        },
        width: {
            type: Number,
            default: 120
        },
        position: {
            required: false,
            type: Array,
            default: () => ['left', 'bottom', 'left', 'top']
        },
        margin:{
            required:false,
            type: Array,
            default: () => [0,0]
        },
        visible: {
            type: Boolean,
            default: false
        },
        cbItemChanged: {
            type: Function,
            default: ()=>{}
        },
        animation: {
            required: false,
            type: String,
            default: 'ani-fade'
        }
    },
    data () {
        return {
            ddStyle:{}
        }
    },
    methods: {
        open() {
            this.setPosition()
            document.addEventListener('resize', this.resizeEvent)
            setTimeout(() => document.addEventListener(this.trigger, this.outEvent), 10)
        },

        close() {          
            document.removeEventListener('resize', this.resizeEvent)
            document.removeEventListener(this.trigger, this.outEvent)
        },

        resizeEvent() {
            this.setPosition()
        },

        outEvent(evt) {
            var $dd = this.$el.children[1]
            if (this.trigger === 'click' && evt.target !== $dd && !$dd.contains(evt.target)) {
                this.$emit('clickout', evt)
            }else if(this.trigger === 'mouseout' && !this.$el.contains(evt.target)){
                this.$emit('mouseout', evt)
            }
        },

        setPosition() {
            var $link = this.$el.children[0]
            var $dd = this.$el.children[1]
            this.ddStyle = setPosition($link, $dd, this.position, this.margin)
        }
    },
    watch: {
        visible(isVisible) {
            if (isVisible) {
                this.open()
            } else {
                this.close()
            }
        }
    },
    mounted() {
        if (this.visible) {
            this.open()
        }
    },
    destroyed() {
        document.removeEventListener('resize', this.resizeEvent)
        document.removeEventListener(this.trigger, this.outEvent)
    }
  }
</script>

<style lang="scss">
@import '../../assets/style/variables';

.dropdown {
    display: inline-block;
    margin-right: 40px;
    position: relative;            
    .dropdown-label {
        display: inline-block;
    }
    .dropdown-list {
        width: 84px;
        line-height: 24px;
        background:#fff;
        z-index: 22;
        box-shadow: 1px 1px 3px 0px $light-gray-color;
        // position: absolute;
        >li {
            padding-left: 10px;
            font-size: 12px;
            cursor: pointer;
            &:hover,.active {
                background:#F3F3F3
            }
        }
    }
}
.ani-fade-leave-active {
  transition: transform .3s ease, opacity .3s ease;
  opacity: 0;
}
.ani-fade-leave {
  opacity: 1;
}
.ani-fade-enter-active {
  transition: transform .3s ease, opacity .3s ease;
  opacity: 1
}
.ani-fade-enter {
  opacity: 0
}
</style>


// WEBPACK FOOTER //
// src/components/dropdown/dropdown.vue